import { render, staticRenderFns } from "./PurchasePlansSelector.vue?vue&type=template&id=2b03e0c9"
import script from "./PurchasePlansSelector.vue?vue&type=script&lang=js"
export * from "./PurchasePlansSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports